import {defineAsyncComponent} from 'vue';

const importExcel = defineAsyncComponent(() => import('@/views/common/import/ImportExcel.vue'));
const importColumnHideShowPopup = defineAsyncComponent(() =>
  import('@/views/common/import/ImportColumnHideShowPopup.vue'),
);

const IncurredDataPopup = defineAsyncComponent(() => import('@/views/common/IncurredData/IncurredDataPopup.vue'));
const IncurredDataMultiple = defineAsyncComponent(() => import('@/views/common/IncurredData/IncurredDataMultiple.vue'));
const IncurredVoucherDataMultiple = defineAsyncComponent(() =>
  import('@/views/common/IncurredData/IncurredVoucherDataMultiple.vue'),
);
const DeleteRelationPopup = defineAsyncComponent(() => import('@/views/common/DeleteRelationPopup.vue'));
const ConfirmRedirectPopup = defineAsyncComponent(() => import('@/pages/ConfirmRedirectPopup.vue'));

const ismacNotiPopup = defineAsyncComponent(() => import('@/layouts/IsmacNoti.vue'));

const debtInvoiceACTPopup = defineAsyncComponent(() => import('@/views/utility/act/DebtInvoiceACT.vue'));
const voucherGeneratingACTPopup = defineAsyncComponent(() => import('@/views/utility/act/VoucherGeneratingACT.vue'));
const invoiceACTDetail = defineAsyncComponent(() => import('@/views/utility/act/InvoiceACTDetail.vue'));

const InstallDigitalSigningTool = defineAsyncComponent(() =>
  import('@/views/common/kyso/InstallDigitalSigningTool.vue'),
);

const GridErrorPopup = defineAsyncComponent(() => import('@/views/common/gridErrorPopup/GridErrorPopup.vue'));
const NpsServeyPopup = defineAsyncComponent(() => import('@/layouts/NpsServeyPopup.vue'));
const SettingPrintVoucher = defineAsyncComponent(() =>
  import('@/views/common/settingPrintvoucher/SettingPrintVoucher.vue'),
);
const PrintBatchVoucher = defineAsyncComponent(() => import('@/views/common/printBatchVoucher/PrintBatchVoucher.vue'));

const copyDataPopup = defineAsyncComponent(() => import('@/views/copyData/copyDataPopup/CopyDataPopup.vue'));
const notMatchDictionaryPopup = defineAsyncComponent(() =>
  import('@/views/copyData/notMatchDictionaryPopup/NotMatchDictionaryPopup.vue'),
);
const detailNotMatchDictionary = defineAsyncComponent(() =>
  import('@/views/copyData/detailNotMatchDictionary/DetailNotMatchDictionary.vue'),
);
const mappingDictionaryPopup = defineAsyncComponent(() =>
  import('@/views/copyData/mappingDictionaryPopup/MappingDictionaryPopup.vue'),
);

const AriseNoPropertyBudgetSource = defineAsyncComponent(() =>
  import('@/views/common/report/AriseNoPropertyBudgetSource.vue'),
);

export function registerCommonPopup(app) {
  app.component('ImportExcel', importExcel);
  app.component('ImportColumnHideShowPopup', importColumnHideShowPopup);
  app.component('IncurredDataPopup', IncurredDataPopup);
  app.component('IncurredDataMultiple', IncurredDataMultiple);
  app.component('IncurredVoucherDataMultiple', IncurredVoucherDataMultiple);
  app.component('DeleteRelationPopup', DeleteRelationPopup);
  app.component('ConfirmRedirectPopup', ConfirmRedirectPopup);
  app.component('IsmacNotiPopup', ismacNotiPopup);
  app.component('InstallDigitalSigningTool', InstallDigitalSigningTool);
  app.component('GridErrorPopup', GridErrorPopup);
  app.component('NpsServeyPopup', NpsServeyPopup);
  app.component('SettingPrintVoucher', SettingPrintVoucher);
  app.component('PrintBatchVoucher', PrintBatchVoucher);
  app.component('DebtInvoiceACT', debtInvoiceACTPopup);
  app.component('VoucherGeneratingACT', voucherGeneratingACTPopup);
  app.component('InvoiceACTDetail', invoiceACTDetail);
  app.component('CopyDataPopup', copyDataPopup);
  app.component('NotMatchDictionaryPopup', notMatchDictionaryPopup);
  app.component('DetailNotMatchDictionary', detailNotMatchDictionary);
  app.component('MappingDictionaryPopup', mappingDictionaryPopup);
  app.component('AriseNoPropertyBudgetSource', AriseNoPropertyBudgetSource);
}
